
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Title3',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
  },
})
